import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { api } from "../api/client.js";

/** FIX-012 closure (2026-09-07): same truthfulness fix as `ForgotPasswordPage.tsx` — see that file's own doc comment. */
export function ResendVerificationPage() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [emailProviderConfigured, setEmailProviderConfigured] = useState(false);

  async function handleSubmit(event: FormEvent): Promise<void> {
    event.preventDefault();
    setSubmitting(true);
    try {
      const response = await api.post<{ emailProviderConfigured: boolean }>("/auth/resend-verification", null, { email });
      setEmailProviderConfigured(response.emailProviderConfigured);
    } finally {
      setSubmitting(false);
      setSent(true);
    }
  }

  return (
    <div className="login-shell">
      <div className="card login-card">
        <h2>Resend verification email</h2>
        {sent ? (
          <div className="success-banner">
            {emailProviderConfigured ? (
              "If that address has a pending verification, a new verification link has been sent."
            ) : (
              "Email delivery is not configured in this environment, so no email can be sent right now. If that address has a pending verification, contact an operator for help completing it."
            )}
          </div>
        ) : (
          <form onSubmit={(event) => void handleSubmit(event)}>
            <div className="field">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" required autoComplete="username" value={email} onChange={(event) => setEmail(event.target.value)} />
            </div>
            <button type="submit" className="primary" disabled={submitting} style={{ width: "100%" }}>
              {submitting ? "Sending…" : "Resend verification link"}
            </button>
          </form>
        )}
        <div className="auth-links">
          <Link to="/login">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
